(() => {
  const config = JSON.parse(document.getElementById('studio-config')?.textContent || '{}');
  config.root = String(config.root || window.Shopify?.routes?.root || '/').replace(/\/+$/, '') + '/';
  window.Studio = { config, announce(text) { const node = document.getElementById('studio-status'); if (node) node.textContent = text; } };
  document.addEventListener('change', event => { if (event.target.matches('[data-st-auto-submit]')) event.target.form?.requestSubmit(); });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const active = document.activeElement?.closest('.st-navigation-group[open],.st-mobile-menu[open],.st-account-menu details[open]');
    if (active) { active.open = false; active.querySelector('summary')?.focus(); }
    else document.querySelectorAll('.st-navigation-group[open],.st-mobile-menu[open],.st-account-menu details[open]').forEach(item => { item.open = false; });
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.st-navigation-group[open],.st-account-menu details[open]').forEach(item => { if (!item.contains(event.target)) item.open = false; });
  });
  class StudioHeader extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      let previous = scrollY;
      this.addEventListener('focusin', () => { this.classList.remove('st-header-hidden'); previous = scrollY; }, { signal: this.abort.signal });
      if (this.dataset.collapse === 'true') {
        const collapse = () => this.classList.toggle('st-header-collapsed', scrollY > this.offsetHeight);
        window.addEventListener('scroll', collapse, { passive: true, signal: this.abort.signal });
        collapse();
      }
      if (this.dataset.sticky === 'on-scroll-up') window.addEventListener('scroll', () => {
        const current = scrollY;
        if (this.contains(document.activeElement) || this.querySelector('.st-navigation-group[open],.st-mobile-menu[open],.st-account-menu details[open]')) { this.classList.remove('st-header-hidden'); previous = current; return; }
        if (Math.abs(current - previous) < 8) return;
        this.classList.toggle('st-header-hidden', current > previous && current > this.offsetHeight * 2);
        previous = current;
      }, { passive: true, signal: this.abort.signal });
      if (this.dataset.menuTrigger === 'hover' && matchMedia('(hover:hover)').matches) this.querySelectorAll('.st-desktop-nav details').forEach(details => {
        details.addEventListener('mouseenter', () => { details.open = true; }, { signal: this.abort.signal });
        details.addEventListener('mouseleave', () => { if (!details.contains(document.activeElement)) details.open = false; }, { signal: this.abort.signal });
      });
      this.querySelectorAll('.st-navigation-group').forEach(details => {
        details.addEventListener('toggle', () => {
          if (details.open) details.closest('.st-navigation').querySelectorAll(':scope > li > details').forEach(other => { if (other !== details) other.open = false; });
        }, { signal: this.abort.signal });
      });
      this.querySelectorAll('.st-menu-side-group').forEach(details => {
        details.addEventListener('toggle', () => {
          if (details.open) details.closest('.st-menu-columns').querySelectorAll('.st-menu-side-group').forEach(other => { if (other !== details) other.open = false; });
        }, { signal: this.abort.signal });
      });
      this.addEventListener('keydown', event => {
        if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
        const nav = event.target.closest('.st-navigation');
        if (!nav || !event.target.matches('.st-navigation > li > a,.st-navigation > li > details > summary')) return;
        const items = [...nav.querySelectorAll(':scope > li > a,:scope > li > details > summary')];
        let index = items.indexOf(event.target), direction = document.dir === 'rtl' ? -1 : 1;
        index = event.key === 'Home' ? 0 : event.key === 'End' ? items.length - 1 : (index + (event.key === 'ArrowRight' ? direction : -direction) + items.length) % items.length;
        event.preventDefault(); items[index]?.focus();
      }, { signal: this.abort.signal });
      this.querySelectorAll('.st-nav-products').forEach(rail => {
        const progress = rail.parentElement.querySelector('[data-st-menu-progress]');
        if (!progress) return;
        const update = () => { const total = rail.scrollWidth - rail.clientWidth; progress.value = total > 0 ? Math.min(100, Math.abs(rail.scrollLeft) / total * 100) : 100; };
        rail.addEventListener('scroll', update, { passive: true, signal: this.abort.signal });
        window.addEventListener('resize', update, { passive: true, signal: this.abort.signal });
        update();
      });
      document.addEventListener('shopify:block:select', event => {
        this.querySelectorAll('[data-promo-block]').forEach(details => { if (details.dataset.promoBlock === event.detail?.blockId) details.open = true; });
      }, { signal: this.abort.signal });
    }
    disconnectedCallback() { this.abort?.abort(); }
  }
  class StudioSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type=search]'); this.results = this.querySelector('.st-search-results');
      if (!this.input || !this.results || this.dataset.enabled !== 'true') return;
      this.abort = new AbortController();
      this.input.addEventListener('focus', () => { if (!this.input.value.trim()) this.showIdle(); }, { signal: this.abort.signal });
      this.input.addEventListener('input', () => { clearTimeout(this.timer); this.pending?.abort(); this.searchEpoch = (this.searchEpoch || 0) + 1; this.timer = setTimeout(() => this.search(), 220); }, { signal: this.abort.signal });
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') { this.input.focus(); this.hide(); event.preventDefault(); }
        if (!['ArrowDown', 'ArrowUp'].includes(event.key) || this.results.hidden) return;
        const links = [...this.results.querySelectorAll('a')];
        if (!links.length) return;
        const index = links.indexOf(document.activeElement), next = event.key === 'ArrowDown' ? (index + 1) % links.length : (index <= 0 ? links.length - 1 : index - 1);
        event.preventDefault(); links[next]?.focus();
      }, { signal: this.abort.signal });
      document.addEventListener('click', event => { if (!this.contains(event.target)) this.hide(); }, { signal: this.abort.signal });
    }
    hide() { clearTimeout(this.timer); this.pending?.abort(); this.searchEpoch = (this.searchEpoch || 0) + 1; this.results.hidden = true; this.input.setAttribute('aria-expanded', 'false'); }
    showIdle() {
      const idle = this.querySelector('[data-st-search-idle]');
      if (!idle?.content.querySelector('li')) { this.hide(); return; }
      this.results.replaceChildren(idle.content.cloneNode(true)); this.results.hidden = false; this.input.setAttribute('aria-expanded', 'true');
    }
    async search() {
      this.pending?.abort(); this.pending = new AbortController();
      const epoch = this.searchEpoch = (this.searchEpoch || 0) + 1;
      const term = this.input.value.trim();
      this.input.setAttribute('aria-expanded', 'false');
      if (term.length < 2) { if (!term) this.showIdle(); else this.hide(); return; }
      const url = new URL((config.root || '/') + 'search/suggest', location.origin);
      url.searchParams.set('q', term); url.searchParams.set('section_id', 'studio-predictive-search');
      url.searchParams.set('resources[type]', config.searchTypes || 'product'); url.searchParams.set('resources[limit]', String(config.searchLimit || 8));
      try {
        const response = await fetch(url, { signal: this.pending.signal });
        if (!response.ok) throw new Error('Search unavailable');
        const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (epoch !== this.searchEpoch || !this.isConnected) return;
        const list = parsed.querySelector('.st-search-list');
        this.results.replaceChildren();
        if (list && list.children.length) { this.results.append(list); this.results.hidden = false; this.input.setAttribute('aria-expanded', 'true'); }
        else this.hide();
      } catch (error) { if (error.name !== 'AbortError' && epoch === this.searchEpoch) this.hide(); }
    }
    disconnectedCallback() { this.abort?.abort(); this.pending?.abort(); clearTimeout(this.timer); }
  }
  class StudioFooter extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController(); this.mobile = matchMedia('(max-width:767px)');
      this.sync = () => this.querySelectorAll('.st-footer-disclosure').forEach(details => { details.open = !this.mobile.matches || details.dataset.defaultOpen === 'true'; });
      this.mobile.addEventListener?.('change', this.sync, { signal: this.abort.signal }); this.sync();
      this.addEventListener('click', event => { if (!this.mobile.matches && event.target.closest('.st-footer-disclosure > summary')) event.preventDefault(); }, { signal: this.abort.signal });
      document.addEventListener('shopify:block:select', event => { if (this.contains(event.target)) event.target.querySelector('details')?.setAttribute('open', ''); }, { signal: this.abort.signal });
    }
    disconnectedCallback() { this.abort?.abort(); }
  }
  class StudioAnnouncements extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); clearInterval(this.timer);
      this.abort = new AbortController(); this.items = [...this.querySelectorAll('[data-st-announcement]')]; this.index = Math.max(0, this.items.findIndex(item => !item.hidden));
      this.motion = matchMedia('(prefers-reduced-motion:reduce)');
      const pause = this.querySelector('[data-st-announcement-pause]');
      this.paused = pause?.getAttribute('aria-pressed') === 'true';
      this.schedule = () => {
        clearInterval(this.timer);
        if (pause) { pause.setAttribute('aria-pressed', String(this.paused)); pause.setAttribute('aria-label', this.paused ? pause.dataset.resumeLabel : pause.dataset.pauseLabel); pause.textContent = this.paused ? '▶' : 'Ⅱ'; }
        if (this.dataset.autoplay === 'true' && this.items.length > 1 && !this.paused && !this.motion.matches) this.timer = setInterval(() => { if (!this.matches(':hover') && !this.contains(document.activeElement) && !document.hidden) this.move(1); }, Math.max(3, Number(this.dataset.seconds) || 5) * 1000);
      };
      this.querySelector('[data-st-announcement-prev]')?.addEventListener('click', () => this.move(-1), { signal: this.abort.signal });
      this.querySelector('[data-st-announcement-next]')?.addEventListener('click', () => this.move(1), { signal: this.abort.signal });
      pause?.addEventListener('click', () => { this.paused = !this.paused; this.schedule(); }, { signal: this.abort.signal });
      this.motion.addEventListener?.('change', this.schedule, { signal: this.abort.signal });
      document.addEventListener('shopify:block:select', event => { const index = this.items.findIndex(item => item.dataset.blockId === event.detail?.blockId); if (index < 0) return; this.index = index; this.move(0); this.paused = true; this.schedule(); }, { signal: this.abort.signal });
      this.schedule();
    }
    move(step) { if (!this.items.length) return; this.index = (this.index + step + this.items.length) % this.items.length; this.items.forEach((item, i) => { item.hidden = i !== this.index; }); }
    disconnectedCallback() { clearInterval(this.timer); this.abort?.abort(); }
  }
  for (const [name, element] of [['studio-header', StudioHeader], ['studio-search', StudioSearch], ['studio-announcements', StudioAnnouncements], ['studio-footer', StudioFooter]]) if (!customElements.get(name)) customElements.define(name, element);
})();
